<template>
    <navbar position="fixed"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto">
        <template slot-scope="{toggle, isToggled}">
                <router-link v-popover:popover1 class="navbar-brand" to="/">
                    {{webSiteBilgileri.SiteAdi}}
                </router-link>
                <el-popover
                        ref="popover1"
                        popper-class="popover"
                        placement="bottom"
                        width="200"
                        trigger="hover">
                    <div class="popover-body">www.tijenhoca.com <br/> code4edu.com</div>
                </el-popover>
        </template>
        <template slot="navbar-menu">
            <router-link v-popover:popover1 class="navbar-brand" to="/duyurulistesi">
                Tüm duyurular
            </router-link>
            <drop-down tag="li" title="Bazı Bilgiler" icon="now-ui-icons users_circle-08" class="nav-item">
                <nav-link :to="'/sayfa/' + s.sid" v-for="s in statikSayfalars" :key="s.id">
                    {{s.SayfaAdi}}
                </nav-link>
            </drop-down>
        </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  import gql from "graphql-tag";
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    },

    data() {
      return {
        webSiteBilgileri: {}
      }
    },
    apollo: {
      webSiteBilgileri: gql`
      query webSiteBilgileri {
        webSiteBilgileri {
          id
          SiteAdi
          tags
          PodCastAdi
          PodCastKonusu
          Slogan
        }
      }
    `,
        statikSayfalars: gql`
           query statikSayfalars {
            statikSayfalars{
              sid
              SayfaAdi
            }
           }
        `
    }
  }
</script>

<style scoped>

</style>
